import { InjectionToken } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface INavigationService {

  activeComponentSubject: BehaviorSubject<string | undefined>;

  refresh(): void;

  back(): void;

  toErrorPage(message: string): void;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const INavigationServiceToken = new InjectionToken<INavigationService>('INavigationServiceToken');
